<template>
    <div>
        <el-card>
            <div class="title" >账户详情</div>
            <el-table  :data="data" border stripe v-loading="loading" >
                <el-table-column type="index"></el-table-column>
                <el-table-column label="账户登录名" prop="out_uid" ></el-table-column>
                <el-table-column label="账户名" prop="name" ></el-table-column>
                <el-table-column label="描述" prop="desc" ></el-table-column>
                <el-table-column label="账户余额" prop="available_amount_wenan" ></el-table-column>
                <el-table-column label="创建时间" prop="create_time" >
                    <template slot-scope="scope">{{scope.row.create_time | dataFormat }}</template>
                </el-table-column>
                <el-table-column label="更新时间" prop="update_time" >
                    <template slot-scope="scope">{{scope.row.update_time | dataFormat }}</template>
                </el-table-column>
                <el-table-column label="操作" width="150px">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-s-tools" size="mini"  @click="edit">编辑账户</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--<div style="display:flex; margin-top:30px;justify-content:space-around">-->
            <div style="font-size: 16px;margin-top:20px;line-height: 2em;margin-bottom: 10px" v-if="hasAccount===1"> 拨款到专用账户</div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline" v-if="hasAccount===1">
                <el-form-item label="金额">
                    <el-input v-model="formInline.money" placeholder="" type="number"  @input.native="changeRate($event,formInline.money)"></el-input>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input
                            type="textarea"
                            :rows="2"
                            placeholder="请输入内容"
                            v-model="formInline.des" >
                    </el-input>
                </el-form-item>
                <el-form-item style="margin-left: 20px">
                    <el-button type="success" @click="pay" >确定</el-button>
                </el-form-item>
            </el-form>
            <!--</div>-->

        </el-card>



        <!-- ------------------------------------------------------给外部人员打钱 ------------------------------------------------------------------------------------->

        <el-card  style="margin-top: 20px" v-if="staff_list && staff_list.length>0" v-loading="item.loading2" v-for="(item,index) in staff_list" >
          <div class="title" style="margin-right: 20px;margin-bottom: 20px">{{item.name}}</div>

          <div v-show=" item.isshow!==2">
            <!--<el-link class='download' :href="demo" title="下载">下载示例文件</el-link>-->
            <el-button type="info"  @click="staff_list_download(item.demo_url)">
              {{item.demo_url_wenan}}
            </el-button>
            <div style="display: flex;margin-top: 20px;margin-bottom: 20px" >
              <div class="title" style="margin-right: 20px;line-height: 2em">描述:</div>
              <el-input
                  style="width: 50%"
                  type="textarea"
                  :rows="1"
                  placeholder="请输入内容"
                  v-model="item.des" >
              </el-input>

            </div>
            <el-upload
                style="margin-top: 15px"
                class="upload-demo"
                ref="upload"
                action="none"
                :limit="1"
                :on-change="(file, fileList)=>staff_list_handleChange(index,file, fileList)"
                :file-list="item.fileList"
                :before-upload="(file)=>staff_list_beforeAvatarUpload(index,item.cate)">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
              <el-button style="margin-left: 10px;" size="small" type="success" @click="staff_list_multipay(index)">批量拨款</el-button>
            </el-upload>
          </div>


          <div style="margin-top: 20px" v-if="item.isshow!==0">
            <h3>{{item.wenan}}</h3>

            <el-table
                :data="item.list.slice((item.currentPage-1)*item.pagesize, item.currentPage*item.pagesize)"
                style="width: 100%">
              <el-table-column
                  prop="account"
                  label="帐号">
              </el-table-column>
              <el-table-column
                  prop="real_name"
                  label="真实姓名">
              </el-table-column>
              <el-table-column
                  prop="phone"
                  label="手机号">
              </el-table-column>
              <el-table-column
                  v-if="item.list[0]['one_pit_fen']"
                  prop="one_pit_fen"
                  label="税费（元）">
              </el-table-column>
              <el-table-column
                  prop="money_fen"
                  label="打款金额(元)">
              </el-table-column>
              <el-table-column
                  prop="remark"
                  label="备注">
              </el-table-column>

            </el-table>

            <el-pagination
                layout="total,prev, pager, next"
                @current-change="(currentPage) =>staff_list_current_change(index,currentPage)"
                :total="item.total"
                :page-size="item.pagesize"
                background
            >
            </el-pagination>

          </div>
          <el-button style="margin-top: 10px" size="small" type="success" @click="staff_list_confirm(index,item.oper,item.ent)" v-show="item.isshow===2">确认信息</el-button>
        </el-card>


<!--        <el-card  style="margin-top: 20px"  v-loading=" no_staff.loading2" v-if="hasAccount===1&&!identity">
            <div class="title" style="margin-right: 20px;margin-bottom: 20px">批量拨款-给非在库员工（需上传excel）</div>

            <div v-show=" no_staff.isshow!==2">
                &lt;!&ndash;<el-link class='download' :href="demo" title="下载">下载示例文件</el-link>&ndash;&gt;
                <el-button type="info"  @click="no_staff_download()">
                    下载示例文件
                </el-button>
                <div style="display: flex;margin-top: 20px;margin-bottom: 20px" >
                    <div class="title" style="margin-right: 20px;line-height: 2em">描述:</div>
                    <el-input
                            style="width: 50%"
                            type="textarea"
                            :rows="1"
                            placeholder="请输入内容"
                            v-model=" no_staff.des" >
                    </el-input>

                </div>
                <el-upload
                        style="margin-top: 15px"
                        class="upload-demo"
                        ref="upload"
                        action="none"
                        :limit="1"
                        :on-change="no_staff_handleChange"
                        :file-list="no_staff.fileList"
                        :before-upload="no_staff_beforeAvatarUpload">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    <el-button style="margin-left: 10px;" size="small" type="success" @click="no_staff_multipay">批量拨款</el-button>
                </el-upload>
            </div>


            <div style="margin-top: 20px" v-if="no_staff.isshow!==0">
                <h3>{{no_staff.wenan}}</h3>

                <el-table
                        v-loading="no_staff_loading"
                        :data="no_staff.list.slice((no_staff.currentPage-1)*no_staff.pagesize, no_staff.currentPage*no_staff.pagesize)"
                        style="width: 100%">
                    <el-table-column
                            prop="account"
                            label="帐号">
                    </el-table-column>
                    <el-table-column
                            prop="real_name"
                            label="真实姓名">
                    </el-table-column>
                    <el-table-column
                            prop="phone"
                            label="手机号">
                    </el-table-column>
                    <el-table-column
                        v-if="no_staff.list[0]['one_pit_fen']"
                        prop="one_pit_fen"
                        label="税费（元）">
                    </el-table-column>
                    <el-table-column
                            prop="money_fen"
                            label="打款金额(元)">
                    </el-table-column>
                    <el-table-column
                            prop="remark"
                            label="备注">
                    </el-table-column>

                </el-table>

                <el-pagination
                        layout="total,prev, pager, next"
                        @current-change="no_staff_current_change"
                        :total="no_staff.total"
                        :page-size="no_staff.pagesize"
                        background
                >
                </el-pagination>

            </div>
            <el-button style="margin-top: 10px" size="small" type="success" @click="no_staff_confirm" v-show="no_staff.isshow===2">确认信息</el-button>

        </el-card>-->


        <!-- ------------------------------------------------------给内部人员打钱 ------------------------------------------------------------------------------------->


<!--
        <el-card  style="margin-top: 20px"  v-loading="staff.loading2" v-if="hasAccount===1">
            <div class="title" style="margin-right: 20px;margin-bottom: 20px"  v-if="identity">批量拨款-给任务中员工（需上传excel）</div>
            <div class="title" style="margin-right: 20px;margin-bottom: 20px" v-else>批量拨款-给在库员工（需上传excel）</div>

            <div v-show="staff.isshow!==2">
                &lt;!&ndash;<el-link class='download' :href="demo_staff" title="下载" >下载示例文件</el-link>&ndash;&gt;
                <el-button type="info"  @click="staff_download()">
                    下载示例文件
                </el-button>
                <div style="display: flex;margin-top: 20px;margin-bottom: 20px" >
                    <div class="title" style="margin-right: 20px;line-height: 2em">描述:</div>
                    <el-input
                            style="width: 50%"
                            type="textarea"
                            :rows="1"
                            placeholder="请输入内容"
                            v-model="staff.des" >
                    </el-input>
                </div>
                <el-upload
                        style="margin-top: 15px"
                        class="upload-demo"
                        ref="upload"
                        action="none"
                        :limit="1"
                        :on-change="staff_handleChange"
                        :file-list="staff.fileList"
                        :before-upload="staff_beforeAvatarUpload">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    <el-button style="margin-left: 10px;" size="small" type="success" @click="staff_multipay">批量拨款</el-button>
                </el-upload>
            </div>
            <div style="margin-top: 20px" v-if="staff.isshow!==0">
                <h3>{{staff.wenan}}</h3>
                <el-table
                        v-loading="staff_loading"
                        :data="staff.list.slice((staff.currentPage-1)*staff.pagesize,staff.currentPage*staff.pagesize)"
                        style="width: 100%">
                    <el-table-column
                            prop="account"
                            label="身份证号">
                    </el-table-column>
                    <el-table-column
                            prop="real_name"
                            label="真实姓名">
                    </el-table-column>
                    <el-table-column
                            prop="phone"
                            label="手机号">
                    </el-table-column>
                    <el-table-column
                            prop="money_fen"
                            label="打款金额(元)">
                    </el-table-column>
                     <el-table-column
                            v-if="staff.list[0]['one_pit_fen']"
                            prop="one_pit_fen"
                            label="税费（元）">
                    </el-table-column>
                    <el-table-column
                            prop="remark"
                            label="备注">
                    </el-table-column>

                </el-table>

                <el-pagination
                        layout="total, prev, pager, next"
                        @current-change="staff_current_change"
                        :total="staff.total"
                        :page-size="staff.pagesize"
                        background
                >
                </el-pagination>

            </div>
            <el-button style="margin-top: 10px" size="small" type="success" @click="staff_confirm" v-show="staff.isshow===2">确认信息</el-button>

        </el-card>
-->




        <!-- ------------------------------------------------------交易列表------------------------------------------------------------------------------------->
        <el-tabs v-model="activeName"  @tab-click="handleClick"  style="margin-top: 20px" v-if="hasAccount===1">
            <el-tab-pane label="交易列表" name="transaction">
                <el-table  :data="account" border stripe>
                    <el-table-column type="index"></el-table-column>
                    <el-table-column label="交易号" prop="out_biz_no"></el-table-column>
                    <el-table-column label="状态" prop="status_wenan" ></el-table-column>
                    <el-table-column label="描述" prop="wenan" ></el-table-column>
                    <el-table-column label="备注" prop="remark" ></el-table-column>
<!--                    <el-table-column label="其他" prop="other" ></el-table-column>-->
                    <el-table-column label="创建时间" prop="create_time">
                        <template slot-scope="scope">{{scope.row.create_time | dataFormat }}</template>
                    </el-table-column>
                    <el-table-column label="更新时间" prop="update_time" >
                        <template slot-scope="scope">{{scope.row.update_time | dataFormat }}</template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="danger" v-show="scope.row.can_edit==1" @click="edit_Fix(scope.row.out_biz_no)">编辑</el-button>
                            <el-button type="primary" icon="el-icon-more" size="mini"  @click="toDetail(scope.row.detail_url)" v-if="scope.row.detail_url">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryInfo.pagenum"
                        :page-sizes="[5, 10, 15, 20]"
                        :page-size="queryInfo.pagesize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        background
                ></el-pagination>
            </el-tab-pane>
            <el-tab-pane label="回单列表" name="receipt">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <el-button type="primary" @click="askReceipt">申请回单</el-button>
                    </el-col>
                </el-row>
                <el-table  :data="receipt_list" border stripe>
                    <el-table-column type="index"></el-table-column>
                    <el-table-column label="名称" prop="name"></el-table-column>
                    <el-table-column label="状态" prop="status_wenan" ></el-table-column>
                    <el-table-column label="创建时间" prop="create_time">
                        <template slot-scope="scope">{{scope.row.create_time | dataFormat }}</template>
                    </el-table-column>
                    <el-table-column label="更新时间" prop="update_time" >
                        <template slot-scope="scope">{{scope.row.update_time | dataFormat }}</template>
                    </el-table-column>
                    <el-table-column label="文件">
                        <template slot-scope="scope">
                            <el-button type="primary"  @click="pdfTo(scope.row.url)" v-if="scope.row.url.length!==0">点击查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        @size-change="receipt_handleSizeChange"
                        @current-change="receipt_handleCurrentChange"
                        :current-page="receipt_queryInfo.pagenum"
                        :page-sizes="[5, 10, 15, 20]"
                        :page-size="receipt_queryInfo.pagesize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="receipt_total"
                        background
                ></el-pagination>
            </el-tab-pane>
            <el-tab-pane label="发票列表" name="bill" v-if="isHR||identity">
                <el-row :gutter="20" v-if="identity">
                    <el-col :span="4">
                        <el-button type="primary" @click="askBill">去开票</el-button>
                    </el-col>
                </el-row>
                <el-table  :data="bill_list" border stripe>
                    <el-table-column type="index"></el-table-column>
                    <el-table-column label="名称" prop="name"></el-table-column>
                    <el-table-column label="状态" prop="status_wenan" ></el-table-column>
                    <el-table-column label="图片列表">
                        <template slot-scope="scope"><el-link v-for="item in scope.row.pic_list" :href=item target="_blank">{{item}}</el-link></template>
                    </el-table-column>
                  <el-table-column label="运单号">
                        <template slot-scope="scope"> {{scope.row.express_no}} </template>
                    </el-table-column>
<!--                    <el-table-column label="图片">
                        <template slot-scope="scope"><el-link :href=scope.row.url target="_blank">{{scope.row.url}}</el-link></template>
                    </el-table-column>-->
                    <el-table-column label="创建时间" prop="create_time">
                        <template slot-scope="scope">{{scope.row.create_time | dataFormat }}</template>
                    </el-table-column>
                    <el-table-column label="更新时间" prop="update_time" >
                        <template slot-scope="scope">{{scope.row.update_time | dataFormat }}</template>
                    </el-table-column>
                     <el-table-column label="操作"  v-if="isHR">
                        <template slot-scope="scope">
                            <el-button type="primary"  @click="edit_Bill(scope.row.id)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        @size-change="bill_handleSizeChange"
                        @current-change="bill_handleCurrentChange"
                        :current-page="bill_queryInfo.pagenum"
                        :page-sizes="[5, 10, 15, 20]"
                        :page-size="bill_queryInfo.pagesize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="bill_total"
                        background
                ></el-pagination>
            </el-tab-pane>
        </el-tabs>

        <Input :labels="info" @confirm="Todo" @cancel="Cancel" v-if="isTodo"></Input>
        <Input :labels="message" @confirm="Todo_Message" @cancel="Cancel_Message" v-if="isMessage"></Input>
        <Input :labels="bill" @confirm="Todo_Bill" @cancel="Cancel_Bill" v-if="isBill" :idoptions="idoptions"></Input>

        <Input :labels="fix" @confirm="Todo_Fix" @cancel="Cancel_Fix" v-if="isFix"  ></Input>

        <h2 v-if="hasAccount===2" style="float:right">请先点击"编辑账户"补充账户名信息，才能进行其他操作</h2>

    </div>
</template>

<script>
    import {putObject} from '../ossload.js'
    import Input from "../input"
    export default {
        name: "detail",
        components:{
            Input
        },
        inject:['reload'],
        data () {
            return {
                loading: false,
                id:0,
                data:[],
                account:[],
                queryInfo: {
                    query: '',
                    pagenum: 1,
                    pagesize: 10
                },
                total: 0,
                offset:0,
                receipt_queryInfo: {
                    query: '',
                    pagenum: 1,
                    pagesize: 10
                },
                receipt_total: 0,
                receipt_offset:0,
                bill_queryInfo: {
                    query: '',
                    pagenum: 1,
                    pagesize: 10
                },
                bill_total: 0,
                bill_offset:0,
                formInline: {
                    money: 0,
                    des: ''
                },
                staff:{
                    isshow:0,
                    active:0,
                    loading2:false,
                    des:"",
                    progress:0,
                    list:[],
                    fileList: [],
                    parse_key:"",
                    url:"",
                    pagesize:10,//每页的数据条数
                    currentPage:1,//默认开始页面
                    total:0,
                    wenan:"",
                },
                no_staff:{
                    isshow:0,
                    active:0,
                    loading2:false,
                    des:"",
                    progress:0,
                    list:[],
                    fileList: [],
                    parse_key:"",
                    url:"",
                    pagesize:10,//每页的数据条数
                    currentPage:1,//默认开始页面
                    total:0,
                    wenan:"",
                },
                staff_loading:true,
                no_staff_loading:true,
                demo:"",
                oldoffset:0,
                receipt_oldoffset:0,
                activeName: 'transaction',
                hasAccount:0,
                receipt_list:[],
                bill_list:[],
                info:[{
                    key: "start_date",
                    name:"开始日期",
                    type:"time",
                    must_write:1
                },{
                    key:"end_date",
                    name:"结束日期",
                    type:"time",
                    must_write:1
                }],
                isTodo:false,
                message:[{
                    key:"name",
                    name:"账户名",
                    type:"normal"
                },{
                    key:"desc",
                    name:"描述",
                    type:"normal"
                }],
                idoptions:[{
                    value: 1,
                    label: '开票中'
                    }, {
                    value: 3,
                    label: '已开票'
                    }],
                isMessage:false,
                 bill:[{
                    key:"url",
                    name:"发票图片",
                    type:"Imgupload",
                    prefix:"tax_receipt",
                }, {
                    key:"status",
                    name:"状态",
                    type:"idoption",
                    value:3,
                   options:[
                     {value:1,label:"开票中"},
                     {value:2,label:"已开票"}
                   ]
                }],
                isBill:false,
                demo_staff:"",
                identity:false,
                isHR:false,
                isFix:false,
                fix:[{
                  key:"fixinfo",
                  name:"图片",
                  type:"Imgupload",
                  prefix:"order_log",
                  muli:true
                }],
                staff_list:[],
            }
        },
        created () {
            this.id = this.$route.params.id
            this.accountInfo();
            this.fetchData();
            this.fetchAccount();

            var sign  = JSON.parse(window.sessionStorage.getItem('sign'));
            sign.forEach(e => {
                if(e=="flex_staff"){
                   this.identity = true;
                }
                if(e=="hr"){
                    this.isHR = true;
                }
            });

        },
        methods:{
            changeRate(e,input){
                e.target.value=(e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
                this.input=e.target.value
                this.formInline.money=this.input
            },
            async  accountInfo(){
              const {data: res} = await this.$http.post('',
                  {
                    "oper": "info",
                    "ent": "account",
                    "info": {
                      "aid": this.id
                    }
                  }
              )
              console.log(res)
              let list = res.data.pay_cate_list;
              console.log(list)
              for(var i=0;i<list.length;i++){
                this.staff_list.push({
                  oper:list[i].oper,
                  ent: list[i].ent,
                  demo_url_wenan:list[i].demo_url_wenan,
                  name:list[i].name,
                  cate:list[i].cate,
                  demo_url:list[i].demo_url,
                  isshow:0,
                  active:0,
                  loading2:false,
                  des:"",
                  progress:0,
                  list:[],
                  fileList: [],
                  parse_key:"",
                  url:"",
                  pagesize:10,//每页的数据条数
                  currentPage:1,//默认开始页面
                  total:0,
                  wenan:"",
                })
              }
              console.log(this.staff_list)
            },
            //账户详情
            async fetchData () {
                this.loading = true
                const {data: res} = await this.$http.post('',
                    {
                        "oper": "get_one",
                        "ent": "account",
                        "info": {
                            "id": this.id
                        }
                    }
                )

                console.log(res)
                if(res.code !=0){
                    this.$message({
                        message:res.msg,
                        duration:6000
                    });;
                }
                if(res.data.name.length!=0){
                    this.hasAccount=1;
                }
                else{
                    this.hasAccount=2;
                }
                for(let i of this.message){
                    i["value"]=res.data[i["key"]]
                }
                console.log(this.message)
                this.data.push(res.data);
                this.loading=false;

            },

            //交易列表
            async fetchAccount (){
                const { data: res2 } = await this.$http.post('',
                    {
                        "oper": "get_account_multi",
                        "ent": "order_log_id",
                        "info": {
                            "aid":this.id,
                            "count":this.queryInfo.pagesize,
                            "offset":this.offset,
                        }

                    }
                )
                console.log(res2)
                if(res2.code !=0){
                    this.$message({
                        message:res.msg,
                        duration:6000
                    });;
                    return
                }
                this.total = res2.data.total_count;
                this.oldoffset=this.offset;
                this.offset+=this.queryInfo.pagesize;
                this.account=res2.data.data_list;
            },

            //回执列表
            async fetchReceipt(){
                const { data: res3 } = await this.$http.post('',
                    {
                        "oper": "get_account_multi",
                        "ent": "receipt",
                        "info": {
                            "aid":this.id,
                            "count":this.receipt_queryInfo.pagesize,
                            "offset":this.receipt_offset,
                        }
                    }
                )
                console.log(res3)
                if(res3.code !=0){
                    this.$message(res3.msg);
                    return
                }
                this.receipt_total = res3.data.total_count;
                this.receipt_oldoffset=this.receipt_offset;
                this.receipt_offset+=this.receipt_queryInfo.pagesize;
                this.receipt_list=res3.data.data_list;
            },

            //发票列表
             async fetchBill(){
                const { data: res3 } = await this.$http.post('',
                    {
                        "oper": "get_multi",
                        "ent": "tax_receipt",
                        "info": {
                            "aid":this.id,
                            "count": this.bill_queryInfo.pagesize,
                            "offset":this.bill_offset,
                        }
                    }
                )
                console.log(res3)
                if(res3.code !=0){
                    this.$message(res3.msg);
                    return
                }
                this.bill_total = res3.data.total_count;
                this.bill_oldoffset=this.bill_offset;
                this.bill_offset+=this.bill_queryInfo.pagesize;
                this.bill_list=res3.data.data_list;
            },


            //上传文件
            async submitUpload(cate) {
                var that=this;
                if(cate==="staff"){
                    await putObject(this.staff.fileList[0],"pay_multi").then((res)=>{
                        that.staff.url=res.url});
                }else if(cate==="no_staff"){
                    await putObject(this.no_staff.fileList[0],"pay_multi").then((res)=>{
                        that.no_staff.url=res.url});
                }
            },
            staff_handleChange(file, fileList) {
                this.staff.fileList = fileList;
            },
            no_staff_handleChange(file, fileList) {
                this.no_staff.fileList = fileList;
            },
            staff_list_handleChange(index,file, fileList) {
              console.log("change====")
              console.log(file)
              this.staff_list[index].fileList = fileList;
              console.log(this.staff_list[index].fileList)
              console.log(this.staff_list[index].fileList.length)
            },
            //自动解析excel表格
            staff_beforeAvatarUpload() {
                this.staff.isshow=1;
                this.staff_loading=true;
                console.log(this.staff_loading)
                let that=this;
                Promise.resolve(this.submitUpload("staff")).then(
                    async function(){
                        let {data: res} = await that.$http.post('',
                            {
                                "oper": "pay_multi_info",
                                "ent": "account",
                                "info": {
                                    "aid":that.id,
                                    "furl":that.staff.url,
                                    "cate":"staff_logon_id"
                                }
                            })
                        console.log("表格")

                        console.log(res)
                        if(res.code==0){
                            that.staff.list=res.data.parse_ret.data_list;
                            for(let i of that.staff.list){
                                i['money_fen']=(i['money_fen']/100).toFixed(2);
                                if(i['one_pit_fen']){
                                    i['one_pit_fen']=(i['one_pit_fen']/100).toFixed(2);
                                }
                            }
                            that.staff.parse_key=res.data.parse_key;
                            that.staff.total=res.data.parse_ret.num;
                            that.staff.wenan=res.data.parse_ret.wenan;
                        }
                        else{
                            that.$message(res.msg);
                            that.staff.isshow=0;
                        }
                        that.staff_loading=false;

                    })

                return false;
            },
          //上传文件
          async submitCommonUpload(index,cate) {
            var that=this;
            console.log("index---");
            if(!this.staff_list[index].fileList[0]) return;
            console.log(this.staff_list[index].fileList[0])
            await putObject(this.staff_list[index].fileList[0],"pay_multi").then((res)=>{
              that.staff_list[index].url=res.url});
          },
          staff_list_beforeAvatarUpload(index,cate) {
            if(!this.staff_list[index].fileList[0]) return;
            this.staff_list[index].isshow=1;
            let that=this;
            Promise.resolve(this.submitCommonUpload(index,cate)).then(
                async function(){
                  let {data: res} = await that.$http.post('',
                      {
                        "oper": "pay_multi_info",
                        "ent": "account",
                        "info": {
                          "aid":that.id,
                          "furl":that.staff_list[index].url,
                          "cate":cate
                        }
                      })
                  console.log("--------",res)
                  if(res.code==0){
                    that.staff_list[index].list=res.data.parse_ret.data_list;
                    console.log(that.staff_list[index].list)
                    for(let i of that.staff_list[index].list){
                      console.log("i['money_fen']",i['money_fen'])
                      i['money_fen']=(i['money_fen']/100).toFixed(2);
                      if(i['one_pit_fen']){
                        i['one_pit_fen']=(i['one_pit_fen']/100).toFixed(2);
                      }
                    }
                    that.staff_list[index].parse_key=res.data.parse_key;
                    that.staff_list[index].total=res.data.parse_ret.num;
                    that.staff_list[index].wenan=res.data.parse_ret.wenan;
                  } else{
                    that.$message(res.msg);
                    that.staff_list[index].isshow=0;
                  }
                  //that.staff_list[index]=false;
                })
            return false;
          },

            no_staff_beforeAvatarUpload() {
                this.no_staff.isshow=1;
                this.no_staff_loading=true;
                console.log(this.no_staff_loading)

                let that=this;
                Promise.resolve(this.submitUpload("no_staff")).then(
                    async function(){
                        let {data: res} = await that.$http.post('',
                            {
                                "oper": "pay_multi_info",
                                "ent": "account",
                                "info": {
                                    "aid":that.id,
                                    "furl":that.no_staff.url,
                                    "cate":""
                                }
                            })
                        console.log(res)
                        if(res.code==0){
                            that.no_staff.list=res.data.parse_ret.data_list;
                            for(let i of that.no_staff.list){
                                console.log(i['money_fen'])
                                i['money_fen']=(i['money_fen']/100).toFixed(2);
                               if(i['one_pit_fen']){
                                    i['one_pit_fen']=(i['one_pit_fen']/100).toFixed(2);
                                }
                            }
                            that.no_staff.parse_key=res.data.parse_key;
                            that.no_staff.total=res.data.parse_ret.num;
                            that.no_staff.wenan=res.data.parse_ret.wenan;
                        }
                        else{
                            that.$message(res.msg);
                            that.no_staff.isshow=0;

                        }
                        that.no_staff_loading=false;
                    })
                return false;
            },
            //翻页
            handleCurrentChange (newSize) {
                this.queryInfo.pagenum = newSize;
                this.offset=(newSize-1)*this.queryInfo.pagesize;
                this.oldoffset=this.offset;
                this.fetchAccount ()
            },
            handleSizeChange (newSize) {
                this.queryInfo.pagesize = newSize
                this.offset=0
                this.oldoffset=this.offset;
                this.fetchAccount ()
            },

            receipt_handleCurrentChange (newSize) {
                this.receipt_queryInfo.pagenum = newSize;
                this.receipt_offset=(newSize-1)*this.receipt_queryInfo.pagesize;
                this.receipt_oldoffset=this.receipt_offset;
                this.fetchReceipt ()
            },
            receipt_handleSizeChange (newSize) {
                this.receipt_queryInfo.pagesize = newSize
                this.receipt_offset=0
                this.receipt_oldoffset=this.receipt_offset;
                this.fetchReceipt ()
            },

            staff_current_change:function(currentPage){
                this.staff.currentPage = currentPage;
            },

            no_staff_current_change:function(currentPage){
                this.no_staff.currentPage = currentPage;
            },
            staff_list_current_change:function(index,currentPage){
              this.staff_list[index].currentPage = currentPage;
            },
            //打款
            pay(){
                this.$confirm('此操作将拨款，是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async() => {
                    let data=JSON.parse(JSON.stringify(this.formInline))
                    data.money=Number(data.money)*100;
                    const {data: res} = await this.$http.post('',
                        {
                            "oper": "trans_in",
                            "ent": "account",
                            "info": {
                                "aid": this.id,
                                "amount": data.money,
                                "remark": data.des
                            }
                        })
                    console.log(res)
                    if(res.code==0){
                        window.open(res.data.url)
                    }
                    else{
                        this.$message({
                            message:res.msg,
                            duration:6000
                        });;
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消拨款'
                    });
                });
            },

            staff_multipay(){
                if(this.staff.url.length==0){
                    this.$message({
                        message:"未上传表格",
                        duration:6000
                    })
                    return;
                }
                this.staff.active++;
                this.staff.isshow=2;
            },

            no_staff_multipay(){
                if(this.no_staff.url.length==0){
                    this.$message({
                        message:"未上传表格",
                        duration:6000
                    })
                    return;
                }
                this.no_staff.active++;
                this.no_staff.isshow=2;
                // this.no_staff.loading=true;
            },
             staff_list_multipay(index){
              if(this.staff_list[index].url.length==0){
                this.$message({
                  message:"未上传表格",
                  duration:6000
                })
                return;
              }
              this.staff_list[index].active++;
              this.staff_list[index].isshow=2;
              // this.no_staff.loading=true;
            },
            toDetail(url){
                const aTag = document.createElement('a')
                aTag.href = url;
                aTag.click()
            },


            edit(){
                this.isMessage=true;
            },

            async staff_confirm(){
                this.$confirm('此操作将拨款，是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    let that=this;
                    this.staff.loading2=true;
                    if(this.identity){
                        var {data: res} = await that.$http.post('',
                        {
                            "oper": "pay_multi_mid",
                            "ent": "flex_staff_account",
                            "info": {
                                "aid":that.id,
                                "remark":that.staff.des,
                                "parse_key":that.staff.parse_key
                            }
                        })
                    }
                    else{
                       var {data: res} = await that.$http.post('',
                        {
                            "oper": "pay_multi",
                            "ent": "account",
                            "info": {
                                "aid":that.id,
                                "remark":that.staff.des,
                                "parse_key":that.staff.parse_key
                            }
                        })
                    }
                    console.log(res)
                    if(res.code==0){
                        that.staff.isshow=0;
                        this.staff.loading2=false;
                        that.staff.active=0;
                        that.$message("操作成功");
                    }
                    else{
                        that.$message(res.msg);
                    }
                    that.staff.fileList=[];
                    that.staff.des="";
                    this.offset=this.oldoffset;
                    this.fetchAccount ();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消拨款'
                    });
                });
            },
            async no_staff_confirm(){
                this.$confirm('此操作将拨款，是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    let that=this;
                    this.no_staff.loading2=true;
                    let {data: res} = await that.$http.post('',
                        {
                            "oper": "pay_multi",
                            "ent": "account",
                            "info": {
                                "aid":that.id,
                                "remark":that.no_staff.des,
                                "parse_key":that.no_staff.parse_key
                            }
                        })
                    console.log(res)
                    if(res.code==0){
                        that.no_staff.isshow=0;
                        this.no_staff.loading2=false;
                        that.no_staff.active=0;
                        that.$message("操作成功");
                    }
                    else{
                        that.$message(res.msg);
                    }
                    that.no_staff.fileList=[];
                    that.no_staff.des="";
                    this.offset=this.oldoffset;
                    this.fetchAccount ();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消拨款'
                    });
                });
            },
          async  staff_list_confirm(index,oper,ent){
            this.$confirm('此操作将拨款，是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(async () => {
              let that=this;
              this.staff_list[index].loading2=true;
              let {data: res} = await that.$http.post('',
                  {
                    "oper": oper ,
                    "ent":  ent,
                    "info": {
                      "aid":that.id,
                      "remark":that.staff_list[index].des,
                      "parse_key":that.staff_list[index].parse_key
                    }
                  })
              console.log(res)
              if(res.code==0){
                that.staff_list[index].isshow=0;
                that.staff_list[index].loading2=false;
                that.staff_list[index].active=0;
                that.$message("操作成功");
              }
              else{
                that.$message(res.msg);
              }
              that.staff_list[index].fileList=[];
              that.staff_list[index].des="";
              this.offset=this.oldoffset;
              this.fetchAccount ();
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消拨款'
              });
            });
          },
            askReceipt(){
                this.isTodo=true;
            },
            askBill(){
                 this.$router.push({ name: 'bill', params: { id: this.id }});
            },
            //申请回单
            async Todo(val){
                val["aid"]=this.id;
                console.log(val);
                const { data: res } = await this.$http.post('',
                    {
                        "oper": "apply",
                        "ent": "receipt",
                        "info":val
                    }
                )
                console.log(res)
                if(res.code==0){
                    this.$message("操作成功");
                    this.receipt_offset=this.receipt_oldoffset;
                    this.fetchReceipt();
                    this.isTodo=false;
                }
                else{
                    this.$message({
                        message:res.msg,
                        duration:6000
                    });
                }
            },

            //编辑账户
            async Todo_Message(val){
                console.log(val)
                val["id"]=this.id;
                const { data: res } = await this.$http.post('',
                    {
                        "oper": "edit",
                        "ent": "account",
                        "info": val
                    }
                )
                console.log(res)
                if(res.code==0){
                    this.$message("操作成功");
                    this.isMessage=false;
                    this.reload();
                }
                else{
                    this.$message({
                        message:res.msg,
                        duration:6000
                    });;
                }
            },

            async Todo_Bill(val){
                console.log(val)
                val["id"]=this.billID;
                val["aid"]=this.id;
                const { data: res } = await this.$http.post('',
                    {
                        "oper": "edit",
                        "ent": "tax_receipt",
                        "info": val
                    }
                )
                console.log(res)
                if(res.code==0){
                    this.$message("操作成功");
                    this.bill_offset=this.bill_oldoffset;
                    this.fetchBill();
                    this.isBill=false;
                }
                else{
                    this.$message({
                        message:res.msg,
                        duration:6000
                    });;
                }
            },
            Cancel(){
                this.isTodo=false;
            },
            Cancel_Message(){
                this.isMessage=false;
            },
            Cancel_Bill(){
                this.isBill=false;
            },
            async Todo_Fix(val){
              console.log(val)
              val["olid"]=this.fixID;
              val["aid"]=this.id;
              const { data: res } = await this.$http.post('',
                  {
                    "oper": "edit",
                    "ent": "order_log_id",
                    "info": val
                  }
              )
              console.log(res)
              if(res.code==0){
                this.$message("操作成功");
                this.offset=this.oldoffset;
                this.fetchAccount();
                this.isFix=false;
              }
              else{
                this.$message({
                  message:res.msg,
                  duration:6000
                });;
              }
            },
            Cancel_Fix(){
              this.isFix=false;
            },
            async edit_Fix(id){
              this.fixID = id
              //获取详情信息
              this.loading = true
              const {data: res} = await this.$http.post('',
                  {
                    "oper": "get_one",
                    "ent": "order_log_id",
                    "info": {
                      "olid": id,
                      "aid":this.id
                    }
                  }
              )

              console.log(res)
              if(res.code !=0){
                this.$message({
                  message:res.msg,
                  duration:6000
                });;
                return;
              }
              for(let i of this.fix){
                i["value"]=res.data[i["key"]]
              }
              console.log("-----------------")
              console.log(this.fix)
              this.loading=false;
              this.isFix = true;
            },
            async edit_Bill(id){
              this.billID = id
                //获取详情信息
              this.loading = true
              const {data: res} = await this.$http.post('',
                  {
                    "oper": "get_by_id",
                    "ent": "tax_receipt",
                    "info": {
                      "id": this.billID,
                      "aid":this.id
                    }
                  }
              )

              console.log(res)
              if(res.code !=0){
                this.$message({
                  message:res.msg,
                  duration:6000
                });;
                return;
              }
              for(let i of this.bill){
                i["value"]=res.data[i["key"]]
              }
              console.log("-----------------")
              console.log(this.bill)
              this.loading=false;
              this.isBill = true;
            },
            pdfTo(url){
                console.log(url)
                window.open(url);
            },
            async download(){
                const {data: url} = await this.$http.post('',
                    {
                        "oper": "info",
                        "ent": "account",
                        "info": {
                        }
                    }
                )
                this.demo=url.data.demo_url;
                this.demo_staff=url.data.demo_url_staff;
                if(url.code !=0){
                    this.$message(url.msg);
                }
            },
            no_staff_download(){
                let that=this;
                Promise.resolve(this.download()).then(function () {
                    console.log(that.demo)
                    if(that.demo.length>0){
                        const aTag = document.createElement('a')
                        aTag.href = that.demo;
                        aTag.click()
                    }
                });
            },
            staff_list_download(_url){
              let that=this;
              this.demo=_url;
              //Promise.resolve(this.download2(_url)).then(function () {
                console.log(that.demo)
                if(that.demo.length>0){
                  const aTag = document.createElement('a')
                  aTag.href = that.demo;
                  aTag.click()
                }
              //});
            },
            download2(demo_url){
              this.demo=demo_url;
            },
            staff_download(){
                let that=this;
                Promise.resolve(this.download()).then(function () {
                    if(that.demo_staff.length>0) {
                        const aTag = document.createElement('a')
                        aTag.href = that.demo_staff;
                        aTag.click()
                    }
                });
            },
            handleClick(tab, event) {
                console.log(tab.name);
                switch(tab.name){
                    case "transaction":this.offset=this.oldoffset;this.fetchAccount(); break;
                    case "receipt": this.receipt_offset=this.oldoffset; this.fetchReceipt();break;
                    case "bill": this.bill_offset=this.oldoffset; this.fetchBill();break;
                }
            }

        }

    }
</script>

<style scoped>
    .title{
        font-size: 14px;
    }
</style>
